var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    transform: "matrix(-4.37114e-08 1 -1 -1.05524e-06 100 0.279053)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.2791,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#FFEDEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3618 36.5766C64.4109 36.3915 63.4477 36.2762 62.4799 36.2316C53.332 35.856 44.1709 35.9436 35.0318 36.4941C33.8076 36.503 32.6298 36.9636 31.7242 37.7875C30.8187 38.6113 30.2492 39.7405 30.1249 40.9584C29.3463 45.7608 29.1674 50.6413 29.5924 55.4878C29.8962 58.9209 30.1849 63.014 34.2799 63.8484C36.9828 64.2698 39.7189 64.4392 42.4531 64.3547L50.9149 64.5084C50.9299 64.5084 50.9562 64.5084 50.9562 64.529C55.6681 64.6172 60.2599 64.3415 64.9606 63.9984C68.7106 63.7359 69.5993 61.0134 70.0643 57.7697C70.6398 53.854 70.775 49.8861 70.4674 45.9403C70.1618 42.0291 70.0474 37.3978 65.3618 36.5766ZM45.9387 56.2941L45.9387 44.1891C49.4599 46.2103 52.9268 48.2091 56.4743 50.2416C52.9531 52.2628 49.4806 54.2616 45.9387 56.2941Z",
    fill: "#F64E60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventYoutube);
export default __webpack_public_path__ + "static/media/canvas_event_youtube.a54ab487796b8f2544eb700f2912cb1d.svg";
export { ForwardRef as ReactComponent };